<template>
    <Auth title="Login" :action="action">
        <AuthWidget
            v-if="!action"
            :social-login-enabled="socialLoginEnabled"
            @selected-action="action = $event"
            @selected-social-login="driver = $event"
        />
        <component
            :is="action === 'login' ? LoginForm : RegisterForm"
            v-if="action"
            :driver="driver"
        />
    </Auth>
</template>

<script setup>
import Auth from "@/Layouts/PWA/Auth.vue";
import AuthWidget from "@/Components/Widgets/PWA/AuthWidget.vue";
import LoginForm from "@/Components/Forms/Auth/PWA/LoginForm.vue";
import RegisterForm from "@/Components/Forms/Auth/PWA/RegisterForm.vue";
import { ref } from "vue";

defineProps({
    socialLoginEnabled: {
        type: Boolean,
        default: false,
    },
});

const action = ref(null);
const driver = ref(null);
</script>
